import type { DmPatientVersion } from '../../../services/dmNotifications';

// Labelled as the work queue's Tags filter.
export const INBOX_TAG_OPTIONS: readonly DmPatientVersion[] = ['V1', 'V2'];

// URL tags as the API's versions; unknown values are dropped rather than sent.
export function tagsToVersions(tags: readonly string[]): DmPatientVersion[] {
    return INBOX_TAG_OPTIONS.filter((tag) => tags.includes(tag));
}
